module.exports = __webpack_public_path__ + "img/fa-money-check-dollar.3d551b76.svg";